import React, { createContext, useMemo } from 'react';
import { getPathWithoutLocale } from '@utils/websiteUrlUtils';

type Theme = 'light' | 'dark';

interface IThemeContext {
  navigationTheme: Theme;
}

const NavigationThemeContext = createContext<IThemeContext>({
  navigationTheme: 'light',
});

/**
 * Nav chrome (logo, menu, language) uses dark mode on the home hero and light
 * on other pages. Theme is derived from the current pathname (via Layout) so
 * the first paint matches the route and matches SSR.
 */
const navigationThemeForPathname = (pathname: string): Theme => {
  const basePath = getPathWithoutLocale(pathname);
  const isHomePage = basePath === '/' || basePath === '';
  return isHomePage ? 'dark' : 'light';
};

interface NavigationThemeProviderProps {
  children: React.ReactNode;
  pathname?: string;
}

const NavigationThemeProvider: React.FC<NavigationThemeProviderProps> = ({ children, pathname = '' }) => {
  const navigationTheme = useMemo(
    () => navigationThemeForPathname(pathname),
    [pathname],
  );

  return (
    <div>
      <NavigationThemeContext.Provider value={{ navigationTheme }}>
        {children}
      </NavigationThemeContext.Provider>
    </div>
  );
};

export { NavigationThemeContext, NavigationThemeProvider };
